const align = [
  "left",
  "center",
  "right"
] as const

export default {
  "base": "py-3 px-4 font-semibold text-sm border-e border-b first:border-s border-t border-muted",
  "variants": {
    "align": {
      "left": "text-left",
      "center": "text-center",
      "right": "text-right"
    }
  },
  "defaultVariants": {
    "align": "left" as typeof align[number]
  }
}